export default {
    headerCard: {
        title: '360\nFeedback',
        description:
            'This comprehensive evaluation helps provide feedback from multiple perspectives including supervisors, peers, and direct reports to support professional development.',
        documentIllustrationAlt: 'Illustration representing documents',
    },
    selfEvaluationHeaderCard: {
        title: 'Self-Assessment',
        description:
            'This self-assessment helps employees reflect on their strengths, challenges, and development priorities to support continuous growth and meaningful discussions.',
        documentIllustrationAlt: 'Illustration representing documents',
    },
    featureItem: {
        developmentFocused: {
            heading: 'Development-focused',
            description:
                'Responses are visible to {{managerPluralLabel}} to support meaningful improvement.',
        },
        timeEstimate: {
            heading: '10-20 Minutes',
            description: 'Estimated completion time',
        },
        diversePerspectives: {
            heading: 'Voices from colleagues matter',
            description: 'Diverse perspectives add unique value to the process.',
        },
    },
    selfEvaluationFeatureItem: {
        developmentFocused: {
            heading: 'Development-focused',
            description:
                'Responses are visible to {{managerPluralLabel}} to support meaningful improvement.',
        },
        timeEstimate: {
            heading: '5–10 Minutes',
            description: 'Estimated completion time',
        },
        diversePerspectives: {
            heading: 'Perspective matters',
            description: 'Your perspective adds unique value to the process.',
        },
    },
    selectReviewee: {
        title: 'Select a colleague to review',
        description:
            'Choose the colleague or group of colleagues you would like to provide feedback for.',
        noEmployeesFound: 'No employees found. Please adjust your search criterias',
    },
    validation: {
        title: 'Form incomplete',
        message: 'Please select at least one reviewee.',
    },
};
